/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Export_Video_DescInputs */

const en_file_export_video_desc = /** @type {(inputs: File_Export_Video_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Burn captions into video`)
};

const fr_file_export_video_desc = /** @type {(inputs: File_Export_Video_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incruster les sous-titres dans la video`)
};

const de_file_export_video_desc = /** @type {(inputs: File_Export_Video_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untertitel in das Video einbrennen`)
};

const it_file_export_video_desc = /** @type {(inputs: File_Export_Video_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masterizza i sottotitoli nel video`)
};

const ru_file_export_video_desc = /** @type {(inputs: File_Export_Video_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Встраивание субтитров в видео`)
};

const es_file_export_video_desc = /** @type {(inputs: File_Export_Video_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grabar subtítulos en el vídeo`)
};

const zh_cn2_file_export_video_desc = /** @type {(inputs: File_Export_Video_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕嵌入视频`)
};

const ja_file_export_video_desc = /** @type {(inputs: File_Export_Video_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`動画に字幕を焼き込む`)
};

const hi_file_export_video_desc = /** @type {(inputs: File_Export_Video_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वीडियो में कैप्शन जोड़ें`)
};

const pt_pt2_file_export_video_desc = /** @type {(inputs: File_Export_Video_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incorporar legendas ao vídeo`)
};

/**
* | output |
* | --- |
* | "Burn captions into video" |
*
* @param {File_Export_Video_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const file_export_video_desc = /** @type {((inputs?: File_Export_Video_DescInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Export_Video_DescInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_file_export_video_desc(inputs)
	if (locale === "de") return de_file_export_video_desc(inputs)
	if (locale === "it") return it_file_export_video_desc(inputs)
	if (locale === "ru") return ru_file_export_video_desc(inputs)
	if (locale === "es") return es_file_export_video_desc(inputs)
	if (locale === "zh-CN") return zh_cn2_file_export_video_desc(inputs)
	if (locale === "ja") return ja_file_export_video_desc(inputs)
	if (locale === "hi") return hi_file_export_video_desc(inputs)
	if (locale === "pt-PT") return pt_pt2_file_export_video_desc(inputs)
	return en_file_export_video_desc(inputs)
});